var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubyAlt3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.045 184.764L176.196 176.142L186 47.916L147.257 126.456L49.045 184.764Z",
    fill: "url(#paint0_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.712 139.915L176.411 176.035L165.489 100.613L135.712 139.915V139.915Z",
    fill: "url(#paint1_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.475 184.592L176.561 176.035L96.4955 169.757L49.475 184.592V184.592Z",
    fill: "url(#paint2_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5885 128.498L49.5825 184.613L69.599 119.081L25.5885 128.498V128.498Z",
    fill: "url(#paint3_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6324 117.426L135.711 140.13L117.307 68.0615L64.6324 117.426V117.426Z",
    fill: "url(#paint4_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.167 73.2215L181.829 69.072L132.035 28.4155L118.167 73.2215V73.2215Z",
    fill: "url(#paint5_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.793 13.688L158.544 13.903L129.261 30.0925L110.793 13.688Z",
    fill: "url(#paint6_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3435 101.451L14 150.471L26.2765 128.111L16.3435 101.451V101.451Z",
    fill: "url(#paint7_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.677 100.613L25.6745 128.928L69.04 119.21L118.576 73.2001L132.551 28.8026L110.535 13.2366L73.125 27.2331C61.3 38.1981 38.467 59.8916 37.65 60.3001C36.833 60.7086 22.6 87.7341 15.677 100.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7435 49.7434C76.35 24.4164 109.224 9.4524 121.866 22.2019C134.508 34.9514 121.092 65.9329 95.5495 91.2599C70.0075 116.587 37.478 132.389 24.75 119.618C12.022 106.847 25.18 75.0704 50.7435 49.7434V49.7434Z",
    fill: "url(#paint8_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5825 184.591L69.4485 118.844L135.346 140.022C111.524 162.382 84.95 181.259 49.5825 184.591Z",
    fill: "url(#paint9_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.662 73.0494L135.582 140.065C155.491 119.124 173.358 96.6349 182.108 68.8999L118.662 73.0494Z",
    fill: "url(#paint10_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.937 69.1365C188.709 48.7115 190.3 19.45 158.329 13.946L132.25 28.4155L181.937 69.1365Z",
    fill: "url(#paint11_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 150.191C14.946 183.903 39.2625 184.419 49.6255 184.591L25.696 128.691L14 150.191Z",
    fill: "#AA3E35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.748 73.2001C134.056 82.5956 164.887 101.473 165.511 101.817C166.478 102.376 178.798 81.0476 181.593 69.0076L118.748 73.2001Z",
    fill: "url(#paint12_radial_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4055 118.844L95.9365 169.95C110.379 161.928 123.587 151.862 135.153 140.065L69.4055 118.844Z",
    fill: "url(#paint13_radial_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5885 128.863L21.826 173.626C28.9211 183.301 38.682 184.161 48.916 183.409C41.52 164.962 26.728 128.111 25.5885 128.863Z",
    fill: "url(#paint14_linear_28_309)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.97 28.5231L184.688 35.9191C181.872 24.0081 173.229 16.3111 158.501 13.9031L131.97 28.5231Z",
    fill: "url(#paint15_linear_28_309)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_309",
    x1: 165.124,
    y1: 200.351,
    x2: 128.832,
    y2: 136.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68F71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DC5242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A72C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72C32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_309",
    x1: 183.184,
    y1: 146.537,
    x2: 136.421,
    y2: 115.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A23E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_309",
    x1: 7838.61,
    y1: 1475.98,
    x2: 7720.91,
    y2: 799.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A23E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_309",
    x1: 47.583,
    y1: 123.833,
    x2: 54.85,
    y2: 170.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E28B6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DA6144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28_309",
    x1: 97.463,
    y1: 79.822,
    x2: 100.129,
    y2: 127.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E08A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C14435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B13430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B13430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_28_309",
    x1: 141.71,
    y1: 35.403,
    x2: 149.708,
    y2: 69.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DF8063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C94D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B13430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B13430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_28_309",
    x1: 117.286,
    y1: 23.2555,
    x2: 151.75,
    y2: 6.03399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C94838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C12D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12D2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_28_309",
    x1: 17.397,
    y1: 111.814,
    x2: 20.235,
    y2: 140.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DA6548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C14433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C14433"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_28_309",
    x1: -2.10348,
    y1: 147.891,
    x2: 131.218,
    y2: 10.8069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C95841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#983734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#AE4231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B93E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DE4E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_28_309",
    x1: 100,
    y1: 161.715,
    x2: 59.8595,
    y2: 151.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A73532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B13439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B13439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_28_309",
    x1: 168.972,
    y1: 113.512,
    x2: 133.303,
    y2: 81.5419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AA3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_28_309",
    x1: 182.087,
    y1: 54.8605,
    x2: 164.307,
    y2: 35.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D3E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AA3E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3E37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_28_309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.872 82.1656) scale(43.7095 43.7095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#923934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_28_309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.328 139.764) scale(58.1145 58.1145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#953A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953A36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_28_309",
    x1: 37.1556,
    y1: 184.548,
    x2: 22.6645,
    y2: 135.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#994939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AA3A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B83936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B83936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_28_309",
    x1: 148.246,
    y1: 21.7506,
    x2: 180.711,
    y2: 36.0696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9392F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A23A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8D463A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D463A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 172,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyAlt3);
export default __webpack_public_path__ + "static/media/ruby-alt3.81507969f2fed0e21babe3d31a2105c3.svg";
export { ForwardRef as ReactComponent };